import React from 'react';

const ClaudeIcon: React.FC = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path fill="#D97757" d="m4.7144 15.9555 4.7174-2.6471.079-.2307-.079-.1275h-.2307l-.7893-.0486-2.6956-.0729-2.3375-.0971-2.2646-.1214-.5707-.1215-.5343-.7042.0546-.3522.4797-.3218.686.0608 1.5179.1032 2.2767.1578 1.6514.0972 2.4468.255h.3886l.0546-.1579-.1336-.0971-.1032-.0972L6.973 9.8356l-2.55-1.6879-1.3356-.9714-.7225-.4918-.3643-.4614-.1578-1.0078.6557-.7225.8803.0607.2246.0607.8925.686 1.9064 1.4754 2.4893 1.8336.3643.3035.1457-.1032.0182-.0728-.164-.2733-1.3539-2.4467-1.445-2.4893-.6435-1.032-.17-.6194c-.0607-.255-.1032-.4674-.1032-.7285L6.287.1335 6.6997 0l.9957.1336.419.3642.6192 1.4147 1.0018 2.2282 1.5543 3.0296.4553.8985.2429.8318.091.255h.1579v-.1457l.1275-1.706.2368-2.0947.2307-2.6957.0789-.7589.3764-.9107.7468-.4918.5828.2793.4797.686-.0668.4433-.2853 1.8517-.5586 2.9021-.3643 1.9429h.2125l.2429-.2429.9835-1.3053 1.6514-2.0643.7286-.8196.85-.9046.5464-.4311h1.0321l.759 1.1293-.34 1.1657-1.0625 1.3478-.8804 1.1414-1.2628 1.7-.7893 1.36.0729.1093.1882-.0183 2.8535-.607 1.5421-.2794 1.8396-.3157.8318.3886.091.3946-.3278.8075-1.967.4857-2.3072.4614-3.4364.8136-.0425.0304.0486.0607 1.5482.1457.6618.0364h1.621l3.0175.2247.7892.522.4736.6376-.079.4857-1.2142.6193-1.6393-.3886-3.825-.9107-1.3113-.3279h-.1822v.1093l1.0929 1.0686 2.0035 1.8092 2.5075 2.3314.1275.5768-.3218.4554-.34-.0486-2.2039-1.6575-.85-.7468-1.9246-1.621h-.1275v.17l.4432.6496 2.3436 3.5214.1214 1.0807-.17.3521-.6071.2125-.6679-.1214-1.3721-1.9246L14.38 17.959l-1.1414-1.9428-.1397.079-.674 7.2552-.3156.3703-.7286.2793-.6071-.4614-.3218-.7468.3218-1.4753.3886-1.9246.3157-1.53.2853-1.9004.17-.6314-.0121-.0425-.1397.0182-1.4328 1.9672-2.1796 2.9446-1.7243 1.8456-.4128.164-.7164-.3704.0667-.6618.4008-.5889 2.386-3.0357 1.4389-1.882.929-1.0868-.0062-.1579h-.0546l-6.3385 4.1164-1.1293.1457-.4857-.4554.0608-.7467.2307-.2429 1.9064-1.3114Z" />
  </svg>
);

const OpenAIIcon: React.FC = () => (
  <svg viewBox="0 0 256 260" aria-hidden="true">
    <path fill="#1c1917" d="M239.184 106.203a64.716 64.716 0 0 0-5.576-53.103C219.452 28.459 191 15.784 163.213 21.74A65.586 65.586 0 0 0 52.096 45.22a64.716 64.716 0 0 0-43.23 31.36c-14.31 24.602-11.061 55.634 8.033 76.74a64.665 64.665 0 0 0 5.525 53.102c14.174 24.65 42.644 37.324 70.446 31.36a64.72 64.72 0 0 0 48.754 21.744c28.481.025 53.714-18.361 62.414-45.481a64.767 64.767 0 0 0 43.229-31.36c14.137-24.558 10.875-55.423-8.083-76.483Zm-97.56 136.338a48.397 48.397 0 0 1-31.105-11.255l1.535-.87 51.67-29.825a8.595 8.595 0 0 0 4.247-7.367v-72.85l21.845 12.636c.218.111.37.32.409.563v60.367c-.056 26.818-21.783 48.545-48.601 48.601Zm-104.466-44.61a48.345 48.345 0 0 1-5.781-32.589l1.534.921 51.722 29.826a8.339 8.339 0 0 0 8.441 0l63.181-36.425v25.221a.87.87 0 0 1-.358.665l-52.335 30.184c-23.257 13.398-52.97 5.431-66.404-17.803ZM23.549 85.38a48.499 48.499 0 0 1 25.58-21.333v61.39a8.288 8.288 0 0 0 4.195 7.316l62.874 36.272-21.845 12.636a.819.819 0 0 1-.767 0L41.353 151.53c-23.211-13.454-31.171-43.144-17.804-66.405v.256Zm179.466 41.695-63.08-36.63L161.73 77.86a.819.819 0 0 1 .768 0l52.233 30.184a48.6 48.6 0 0 1-7.316 87.635v-61.391a8.544 8.544 0 0 0-4.4-7.213Zm21.742-32.69-1.535-.922-51.619-30.081a8.39 8.39 0 0 0-8.492 0L99.98 99.808V74.587a.716.716 0 0 1 .307-.665l52.233-30.133a48.652 48.652 0 0 1 72.236 50.391v.205ZM88.061 139.097l-21.845-12.585a.87.87 0 0 1-.41-.614V65.685a48.652 48.652 0 0 1 79.757-37.346l-1.535.87-51.67 29.825a8.595 8.595 0 0 0-4.246 7.367l-.051 72.697Zm11.868-25.58 28.138-16.217 28.188 16.218v32.434l-28.086 16.218-28.188-16.218-.052-32.434Z" />
  </svg>
);

const CursorIcon: React.FC = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path fill="#1c1917" d="M11.503.131 1.891 5.678a.84.84 0 0 0-.42.726v11.188c0 .3.162.575.42.724l9.609 5.55a1 1 0 0 0 .998 0l9.61-5.55a.84.84 0 0 0 .42-.724V6.404a.84.84 0 0 0-.42-.726L12.497.131a1.01 1.01 0 0 0-.996 0M2.657 6.338h18.55c.263 0 .43.287.297.515L12.23 22.918c-.062.107-.229.064-.229-.06V12.335a.59.59 0 0 0-.295-.51l-9.11-5.257c-.109-.063-.064-.23.061-.23" />
  </svg>
);

const NodeIcon: React.FC = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path fill="#5FA04E" d="M11.998,24c-0.321,0-0.641-0.084-0.922-0.247l-2.936-1.737c-0.438-0.245-0.224-0.332-0.08-0.383 c0.585-0.203,0.703-0.25,1.328-0.604c0.065-0.037,0.151-0.023,0.218,0.017l2.256,1.339c0.082,0.045,0.197,0.045,0.272,0l8.795-5.076 c0.082-0.047,0.134-0.141,0.134-0.238V6.921c0-0.099-0.053-0.192-0.137-0.242l-8.791-5.072c-0.081-0.047-0.189-0.047-0.271,0 L3.075,6.68C2.99,6.729,2.936,6.825,2.936,6.921v10.15c0,0.097,0.054,0.189,0.139,0.235l2.409,1.392 c1.307,0.654,2.108-0.116,2.108-0.89V7.787c0-0.142,0.114-0.253,0.256-0.253h1.115c0.139,0,0.255,0.112,0.255,0.253v10.021 c0,1.745-0.95,2.745-2.604,2.745c-0.508,0-0.909,0-2.026-0.551L2.28,18.675c-0.57-0.329-0.922-0.945-0.922-1.604V6.921 c0-0.659,0.353-1.275,0.922-1.603l8.795-5.082c0.557-0.315,1.296-0.315,1.848,0l8.794,5.082c0.57,0.329,0.924,0.944,0.924,1.603 v10.15c0,0.659-0.354,1.273-0.924,1.604l-8.794,5.078C12.643,23.916,12.324,24,11.998,24z M19.099,13.993 c0-1.9-1.284-2.406-3.987-2.763c-2.731-0.361-3.009-0.548-3.009-1.187c0-0.528,0.235-1.233,2.258-1.233 c1.807,0,2.473,0.389,2.747,1.607c0.024,0.115,0.129,0.199,0.247,0.199h1.141c0.071,0,0.138-0.031,0.186-0.081 c0.048-0.054,0.074-0.123,0.067-0.196c-0.177-2.098-1.571-3.076-4.388-3.076c-2.508,0-4.004,1.058-4.004,2.833 c0,1.925,1.488,2.457,3.895,2.695c2.88,0.282,3.103,0.703,3.103,1.269c0,0.983-0.789,1.402-2.642,1.402 c-2.327,0-2.839-0.584-3.011-1.742c-0.02-0.124-0.126-0.215-0.253-0.215h-1.137c-0.141,0-0.254,0.112-0.254,0.253 c0,1.482,0.806,3.248,4.655,3.248C17.501,17.007,19.099,15.91,19.099,13.993z" />
  </svg>
);

const PowerShellIcon: React.FC = () => (
  <svg viewBox="0 0 128 128" aria-hidden="true">
    <linearGradient id="apf-ps-b" x1="25.336" x2="94.569" y1="98.33" y2="36.847" gradientTransform="matrix(1 0 0 -1 0 128)" gradientUnits="userSpaceOnUse">
      <stop offset="0" stopColor="#5391FE" />
      <stop offset="1" stopColor="#3E6DBF" />
    </linearGradient>
    <path fill="url(#apf-ps-b)" fillRule="evenodd" d="M120.3 18.5H28.5c-2.9 0-5.7 2.3-6.4 5.2L3.7 104.3c-.7 2.9 1.1 5.2 4 5.2h91.8c2.9 0 5.7-2.3 6.4-5.2l18.4-80.5c.7-2.9-1.1-5.3-4-5.3z" clipRule="evenodd" />
    <path fill="#FFF" fillRule="evenodd" d="M77.6 65.5c-.4.8-1.2 1.6-2.6 2.6L33.6 97.9c-2.3 1.6-5.5 1-7.3-1.4-1.7-2.4-1.3-5.7.9-7.3l37.4-27.1v-.6l-23.5-25c-1.9-2-1.7-5.3.4-7.4 2.2-2 5.5-2 7.4 0l28.2 30c1.7 1.8 1.8 4.4.5 6.4zM63.5 87.8h22.3c2.6 0 4.7 2.1 4.7 4.6 0 2.6-2.1 4.6-4.7 4.6H63.5c-2.6 0-4.7-2.1-4.7-4.6 0-2.6 2.1-4.6 4.7-4.6z" clipRule="evenodd" />
  </svg>
);

const PlaywrightIcon: React.FC = () => (
  <svg viewBox="0 0 400 400" fill="none" aria-hidden="true">
    <path d="M161.661 262.296V239.863L99.3324 257.537C99.3324 257.537 103.938 230.777 136.444 221.556C146.302 218.762 154.713 218.781 161.661 220.123V128.11H192.869C189.471 117.61 186.184 109.526 183.423 103.909C178.856 94.612 174.174 100.775 163.545 109.665C156.059 115.919 137.139 129.261 108.668 136.933C80.1966 144.61 57.179 142.574 47.5752 140.911C33.9601 138.562 26.8387 135.572 27.5049 145.928C28.0847 155.062 30.2605 169.224 35.2445 187.928C46.0272 228.433 81.663 306.481 149.01 288.342C166.602 283.602 179.019 274.233 187.626 262.291H161.661V262.296ZM61.0848 188.484L108.946 175.876C108.946 175.876 107.551 194.288 89.6087 199.018C71.6614 203.743 61.0848 188.484 61.0848 188.484Z" fill="#E2574C" />
    <path d="M341.786 129.174C329.345 131.355 299.498 134.072 262.612 124.185C225.716 114.304 201.236 97.0224 191.537 88.8994C177.788 77.3834 171.74 69.3802 165.788 81.4857C160.526 92.163 153.797 109.54 147.284 133.866C133.171 186.543 122.623 297.706 209.867 321.098C297.093 344.47 343.53 242.92 357.644 190.238C364.157 165.917 367.013 147.5 367.799 135.625C368.695 122.173 359.455 126.078 341.786 129.174ZM166.497 172.756C166.497 172.756 180.246 151.372 203.565 158C226.899 164.628 228.706 190.425 228.706 190.425L166.497 172.756ZM223.42 268.713C182.403 256.698 176.077 223.99 176.077 223.99L286.262 254.796C286.262 254.791 264.021 280.578 223.42 268.713ZM262.377 201.495C262.377 201.495 276.107 180.126 299.422 186.773C322.736 193.411 324.572 219.208 324.572 219.208L262.377 201.495Z" fill="#2EAD33" />
  </svg>
);

const TerminalIcon: React.FC = () => (
  <svg viewBox="0 0 16 16" aria-hidden="true">
    <rect x="1.25" y="2" width="13.5" height="12" rx="2" fill="#292524" />
    <path d="m4 6 2.2 2L4 10" fill="none" stroke="#e7e5e4" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.8 10.5h4" stroke="#e7e5e4" strokeWidth="1.3" strokeLinecap="round" />
  </svg>
);

const GenericProcessIcon: React.FC = () => (
  <svg viewBox="0 0 16 16" aria-hidden="true">
    <rect x="1.75" y="2.75" width="12.5" height="10.5" rx="1.5" fill="none" stroke="#a8a29e" strokeWidth="1.3" />
    <path d="M1.75 5.75h12.5" fill="none" stroke="#a8a29e" strokeWidth="1.3" />
  </svg>
);

interface ChildProcess {
  id: string;
  name: string;
  note?: string;
  kind: 'Subagent' | 'Terminal' | 'Process';
  icon: React.ReactNode;
  cpu: number;
  memMb: number;
}

interface AgentDetail {
  task: string;
  thread: string;
  parent?: string;
  stats: Array<{ label: string; value: string }>;
}

interface AgentProcess {
  id: string;
  name: string;
  icon: React.ReactNode;
  cpu: number;
  memMb: number;
  children: ChildProcess[];
  detail: AgentDetail;
}

const AGENTS: AgentProcess[] = [
  {
    id: 'claude',
    name: 'Claude Code',
    icon: <ClaudeIcon />,
    cpu: 18.4,
    memMb: 1840,
    children: [
      { id: 'claude-explore', name: 'explore', note: 'mapping auth call sites', kind: 'Subagent', icon: <ClaudeIcon />, cpu: 6.2, memMb: 410 },
      { id: 'claude-test', name: 'test-runner', note: 'auth integration suite', kind: 'Subagent', icon: <ClaudeIcon />, cpu: 4.1, memMb: 380 },
      { id: 'claude-pwsh', name: 'pwsh', note: 'npm run test -- auth', kind: 'Terminal', icon: <PowerShellIcon />, cpu: 2.3, memMb: 96 },
      { id: 'claude-node', name: 'node', note: 'vite dev server :5173', kind: 'Terminal', icon: <NodeIcon />, cpu: 0.9, memMb: 210 },
      { id: 'claude-mcp', name: 'mcp-server', note: 'playwright', kind: 'Process', icon: <PlaywrightIcon />, cpu: 0.4, memMb: 88 },
    ],
    detail: {
      task: 'Refactor auth flow',
      thread: 'thread_01hqv9d3',
      parent: 'OpenClaw / engineering',
      stats: [
        { label: 'Scope', value: 'repo/api · rw · no net' },
        { label: 'Files', value: '12' },
        { label: 'Tool calls', value: '47' },
        { label: 'Tokens', value: '184k' },
        { label: 'Cost', value: '$1.84' },
      ],
    },
  },
  {
    id: 'codex',
    name: 'Codex',
    icon: <OpenAIIcon />,
    cpu: 7.2,
    memMb: 920,
    children: [
      { id: 'codex-review', name: 'reviewer', note: 'scanning payments diff', kind: 'Subagent', icon: <OpenAIIcon />, cpu: 2.8, memMb: 310 },
      { id: 'codex-bash', name: 'bash', note: 'pytest tests/payments', kind: 'Terminal', icon: <TerminalIcon />, cpu: 1.6, memMb: 120 },
      { id: 'codex-git', name: 'git', note: 'worktree checkout', kind: 'Process', icon: <GenericProcessIcon />, cpu: 0.2, memMb: 34 },
    ],
    detail: {
      task: 'Fix flaky payments tests',
      thread: 'thread_01hqtw7k',
      parent: 'CI / nightly',
      stats: [
        { label: 'Scope', value: 'repo/payments · rw' },
        { label: 'Files', value: '4' },
        { label: 'Tool calls', value: '21' },
        { label: 'Tokens', value: '92k' },
        { label: 'Cost', value: '$0.61' },
      ],
    },
  },
  {
    id: 'cursor',
    name: 'Cursor Agent',
    icon: <CursorIcon />,
    cpu: 4.8,
    memMb: 640,
    children: [
      { id: 'cursor-composer', name: 'composer', note: 'settings page migration', kind: 'Subagent', icon: <CursorIcon />, cpu: 2.1, memMb: 280 },
      { id: 'cursor-node', name: 'node', note: 'next dev :3100', kind: 'Terminal', icon: <NodeIcon />, cpu: 1.2, memMb: 240 },
    ],
    detail: {
      task: 'Migrate settings page',
      thread: 'thread_01hqu2m8',
      stats: [
        { label: 'Scope', value: 'repo/web · rw · net:npm' },
        { label: 'Files', value: '7' },
        { label: 'Tool calls', value: '18' },
        { label: 'Tokens', value: '58k' },
        { label: 'Cost', value: '$0.42' },
      ],
    },
  },
];

const PLAIN_ROWS = [
  { id: 'systemd', name: 'systemd', icon: <GenericProcessIcon />, cpu: 0.1, memMb: 42, before: true },
  { id: 'node-exe', name: 'node.exe', icon: <NodeIcon />, cpu: 1.1, memMb: 180, before: false },
];

const hashSeed = (id: string): number =>
  id.split('').reduce((acc, ch) => acc + ch.charCodeAt(0), 0);

const wobble = (id: string, tick: number, amount: number): number =>
  1 + amount * Math.sin(tick * 1.9 + hashSeed(id));

const formatMem = (mb: number): string =>
  mb >= 1000 ? `${(mb / 1000).toFixed(1)} GB` : `${Math.round(mb)} MB`;

const cpuHeat = (base: number): number => (base >= 10 ? 3 : base >= 5 ? 2 : base >= 2 ? 1 : 0);
const memHeat = (baseMb: number): number => (baseMb >= 1000 ? 3 : baseMb >= 500 ? 2 : baseMb >= 300 ? 1 : 0);

const AgentProcessFigure: React.FC = () => {
  const [tick, setTick] = React.useState(0);
  const [open, setOpen] = React.useState<Record<string, boolean>>({ claude: true });

  React.useEffect(() => {
    const timer = window.setInterval(() => setTick((t) => t + 1), 2000);
    return () => window.clearInterval(timer);
  }, []);

  const toggle = (id: string) => setOpen((prev) => ({ ...prev, [id]: !prev[id] }));

  const usageCells = (id: string, cpu: number, memMb: number) => {
    const liveCpu = Math.max(0.1, cpu * wobble(`${id}:cpu`, tick, 0.16));
    const liveMem = memMb * wobble(`${id}:mem`, tick, 0.03);
    const cpuClass = cpuHeat(cpu) ? `agent-process-heat agent-process-heat--${cpuHeat(cpu)}` : undefined;
    const memClass = memHeat(memMb) ? `agent-process-heat agent-process-heat--${memHeat(memMb)}` : undefined;
    return (
      <>
        <span role="cell" className={cpuClass}>{liveCpu.toFixed(1)}%</span>
        <span role="cell" className={memClass}>{formatMem(liveMem)}</span>
      </>
    );
  };

  const totalCpu = Math.round(
    (PLAIN_ROWS.reduce((sum, row) => sum + row.cpu, 0) +
      AGENTS.reduce((sum, agent) => sum + agent.cpu, 0) +
      6.2) *
      wobble('total:cpu', tick, 0.06)
  );
  const totalMem = Math.round(61 * wobble('total:mem', tick, 0.015));

  const renderPlainRow = (row: (typeof PLAIN_ROWS)[number]) => (
    <div className="agent-process-row" role="row" key={row.id}>
      <span className="agent-process-name" role="cell"><b aria-hidden="true" /><i className="agent-process-icon">{row.icon}</i>{row.name}</span>
      <span role="cell">Process</span>
      {usageCells(row.id, row.cpu, row.memMb)}
    </div>
  );

  const renderAgent = (agent: AgentProcess) => {
    const isOpen = Boolean(open[agent.id]);
    return (
      <div className="agent-process-group" key={agent.id}>
        <div
          className={`agent-process-row agent-process-row--agent${isOpen ? ' agent-process-row--expanded' : ''}`}
          role="row"
        >
          <span role="cell">
            <button
              type="button"
              className="agent-process-name agent-process-name--toggle"
              aria-expanded={isOpen}
              onClick={() => toggle(agent.id)}
            >
              <b aria-hidden="true">›</b>
              <i className="agent-process-icon">{agent.icon}</i>
              {agent.name} ({agent.children.length})
            </button>
          </span>
          <span role="cell"><em>Agent</em></span>
          {usageCells(agent.id, agent.cpu, agent.memMb)}
        </div>

        {isOpen && (
          <>
            {agent.children.map((child) => (
              <div className="agent-process-row agent-process-row--child" role="row" key={child.id}>
                <span className="agent-process-name" role="cell">
                  <i className="agent-process-icon">{child.icon}</i>
                  {child.name}
                  {child.note && <small>{child.note}</small>}
                </span>
                <span role="cell">
                  {child.kind === 'Process' ? 'Process' : <em className="agent-process-type--soft">{child.kind}</em>}
                </span>
                {usageCells(child.id, child.cpu, child.memMb)}
              </div>
            ))}

            <div className="agent-process-detail">
              <div className="agent-process-detail__header">
                <div className="agent-process-detail__session">
                  <strong>{agent.detail.task}</strong>
                  <span className="agent-process-detail__thread">
                    {agent.detail.thread}
                    {agent.detail.parent && <em>· spawned by {agent.detail.parent}</em>}
                  </span>
                </div>
                <span className="agent-process-detail__chat" aria-hidden="true">
                  <svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 2.5h8c.3 0 .5.2.5.5v4.5c0 .3-.2.5-.5.5H5.5L3 10V8H2c-.3 0-.5-.2-.5-.5V3c0-.3.2-.5.5-.5Z" fill="none" stroke="currentColor" strokeWidth="1.1" strokeLinejoin="round" /></svg>
                  Open chat
                </span>
              </div>
              <div className="agent-process-detail__stats">
                {agent.detail.stats.map((item) => (
                  <div key={item.label}><span>{item.label}</span><strong>{item.value}</strong></div>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    );
  };

  return (
    <figure className="agent-process-figure">
      <div className="agent-process-window">
        <header className="agent-process-window__title">
          <div className="agent-process-window__heading">
            <strong>Processes</strong>
            <span>23 running · 3 agents · 10 agent-owned</span>
          </div>
          <div className="agent-process-window__actions" aria-hidden="true">
            <span><svg viewBox="0 0 12 12" aria-hidden="true"><path d="M6 2.2v7.6M2.2 6h7.6" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" /></svg>Run new task</span>
            <span><svg viewBox="0 0 12 12" aria-hidden="true"><circle cx="6" cy="6" r="4.4" fill="none" stroke="currentColor" strokeWidth="1.3" /><path d="M3 9 9 3" fill="none" stroke="currentColor" strokeWidth="1.3" /></svg>End task</span>
          </div>
        </header>

        <div className="agent-process-table" role="table" aria-label="Agent-aware operating system process list">
          <div className="agent-process-row agent-process-row--header" role="row">
            <span role="columnheader">Name</span>
            <span role="columnheader">Type</span>
            <span role="columnheader"><b>{totalCpu}%</b>CPU</span>
            <span role="columnheader"><b>{totalMem}%</b>Memory</span>
          </div>

          {renderPlainRow(PLAIN_ROWS[0])}
          {AGENTS.map(renderAgent)}
          {renderPlainRow(PLAIN_ROWS[1])}
        </div>
      </div>

      <figcaption>
        An agent-aware task manager groups an agent with the subagents and terminal processes it owns. Click an agent to see its process tree and the context the OS holds about it.
      </figcaption>
    </figure>
  );
};

export default AgentProcessFigure;
